import { useEffect } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import { TextHead, TextRegular, Button } from "./InitialRegistPopup.styled";
import { useNavigate } from "react-router-dom";
import { usePageContextFunction } from "../../../../context/PageContext";
import moment from "moment";
import { capitalizeFLetter } from "../../../../utils/function";
import { useFetchEventCategory } from "../../../../networks";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const InitialRegistPopup = ({
  city,
  data,
  registStartDate,
  registEndDate,
  registAnnounceDate,
  selectedForm,
}) => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const { setOpenPopUp: tooglePopUp } = usePageContextFunction();
  const isMobileView = (size?.width || 0) <= 768;
  const schoolCategory = data?.category;
  const competition = data?.competition;
  const cityId = data?.cityId;
  const kota = city.charAt(0).toUpperCase() + city.slice(1);
  const regionName = data?.regionName || kota;

  const currentYears = moment()?.year();

  const { data: dataEventCategoryRaw } = useFetchEventCategory();
  const dataEventCategories =
    dataEventCategoryRaw?.data?.data?.event_categories || [];
  const categoryName =
    competition === "Futsal" ? `Futsal ${schoolCategory}` : competition;
  const competititonId = dataEventCategories?.find(
    (data) => data?.category_name === categoryName
  )?.id;

  moment.locale("id");

  const formattedStartDate = moment(registStartDate).format("D MMMM");
  const formattedEndDate = moment(registEndDate).format("D MMMM YYYY");
  const formattedAnnoucementDate =
    moment(registAnnounceDate).format("D MMMM YYYY");

  const handleRegistrationFlow = () => {
    if (competition === "Dance") {
      // For Dance category
      navigate(
        `/${city}/registrasi/form-dance/${schoolCategory}/${cityId}/${competititonId}`,
        {
          state: {
            preserveCategory: true,
            category: schoolCategory,
          },
        }
      );
    } else {
      // For Futsal category
      navigate(
        `/${city}/registrasi/form/${schoolCategory}/${cityId}/${competititonId}`,
        {
          state: {
            preserveCategory: true,
            category: schoolCategory,
          },
        }
      );
    }
    tooglePopUp(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <TextHead>
        Registrasi Awal Piala by.U {regionName} {currentYears}{" "}
        {competition
          ? capitalizeFLetter(competition) + " " + "Competition"
          : ""}
      </TextHead>
      <TextRegular>
        {competition === "Dance"
          ? `Dance Competition ini dikhususkan untuk kategori SMA/Sederajat. Periode registrasi dibuka pada tanggal ${formattedStartDate} hingga ${formattedEndDate}.`
          : `Calon peserta Piala by.U ${regionName} ${currentYears} harap mengisi
        formulir registrasi awal berikut. Periode registrasi Piala by.U ${kota} 
        dibuka dari tanggal ${formattedStartDate} hingga ${formattedEndDate}.
        Semua data isian menjadi hak panitia penyelenggara sebagai acuan untuk
        memilih peserta. Pengumuman peserta piala by.U ${kota} yakni tanggal
        ${formattedAnnoucementDate}.`}
      </TextRegular>
      <TextRegular fontSize={isMobileView ? "14px" : "18px"}>
        <b style={{ whiteSpace: "pre" }}>
          {competition === "Dance"
            ? isMobileView
              ? `10 Peserta yang terpilih akan dihubungi\npanitia dan membayar biaya registrasi\nsebesar Rp100.000,- `
              : `10 Peserta yang terpilih akan dihubungi panitia dan membayar biaya registrasi\nsebesar Rp100.000,- `
            : isMobileView
            ? `Peserta yang terpilih akan dihubungi panitia dan\nmembayar biaya registrasi sebesar:\nKategori SMP/Sederajat: Rp300.000,-\nKategori SMA/Sederajat: Rp500.000,-`
            : `Peserta yang terpilih akan dihubungi panitia dan membayar biaya registrasi sebesar:\nKategori SMP/Sederajat: Rp300.000,-\nKategori SMA/Sederajat: Rp500.000,-`}
        </b>
      </TextRegular>
      <TextRegular>
        Informasi lebih lanjut, kamu bisa menghubungi contact center kami:
        <b>
          <br />
          085182773460 (WA Saja)
          <br />
          event@byu.id
        </b>
      </TextRegular>
      <Button onClick={handleRegistrationFlow}>Siap, lanjut registrasi</Button>
    </div>
  );
};

export default InitialRegistPopup;
